<template>
    <div>
        <div v-for="tab in tabs">

            <a v-if="tab.type == 'collaborator'" :href="'/dbl-models/' +  model  + '/collaborators'">
                <div class="nav-item">
                    <i class="fal fa-fw" :class="tab.icon"></i>
                    <span>{{ tab.name }}</span>
                </div>
            </a>

            <a v-else-if="target == 'collaborator'" :href="'/dbl-models/' +  model  + '/' + tab.type">
                <div class="nav-item">
                    <i class="fal fa-fw" :class="tab.icon"></i>
                    <span>{{ tab.name }}</span>
                </div>
            </a>

            <div v-else class="nav-item" v-on:click="openDrawer(tab.type)">
                <i class="fal fa-fw" :class="tab.icon"></i>
                <span>{{ tab.name }}</span>
            </div>
        </div>

        <div v-if="type != ''" id="drawer" class="drawer">
            <!--<div class="drawer-header">-->
                <!--<div class="back-wrapper" v-on:click="closeDrawer">-->
                    <!--<div class="drawer-close"><i class="fas fa-chevron-left"></i></div>-->
                    <!--<div class="drawer-name">{{ lang['general.close_drawer'] }}</div>-->
                <!--</div>-->
            <!--</div>-->
            <div class="drawer-type flex-r flex-space"> <!-- v-if="!edit"  -->
                <div class="flex-r flex-stiff clickable mr-3" v-on:click="closeDrawer"><div class="flex-c flex-center"><i class="fas fa-chevron-left mr-2"></i></div><div class="flex-c flex-center">{{ lang['general.back'] }}</div></div>
                <div v-if="type == 'model'" class="drawer-title flex-c flex-center">{{ lang['general.model_settings'] }}</div>
                <div v-if="type != 'model'" class="drawer-title flex-c flex-center">{{ lang['page_type'][type] }}</div>
            </div>
            <div class="drawer-contents">
                <div v-if="items.length > 0" class="drawer-body">

                    <!-- Search Bar - For Assignments, Courses, Modules, Paths, Problems, and Groups -->
                    <div v-if="type == 'assignment' || type == 'problem' || type == 'group' || type == 'module' || type == 'path' || type == 'course'" class="search-wrapper mt-2 mb-2">
                        <i class="fal fa-search"></i>
                        <input id="item-search" autocomplete="off" type="search" class="form-control" :placeholder="lang[type + '.search']" v-model="searchTerm">
                    </div>

                    <div v-if="type == 'module'" class="edit-row mt-3">
                        <label for="shared">Show Modules from Other Models</label>
                        <label class="switch"><input type="checkbox" id="shared" v-model="showSharedModules"><span class="slider-switch round"></span></label>
                    </div>

                    <template v-for="(item, index) in filteredItems">
                        <!-- Module-specific row... sometimes visible, based on sharing settings. -->
                        <template v-if="type == 'module'">
                            <template v-if="(showSharedModules || item.model_id == model)">
                                <div class="item-row" @click="itemDetails(item, type, index)">
                                    <i v-if="item.model_id == model" i class="item-icon flex-stiff fal fa-fw" :class="drawer.icon"></i>
                                    <i v-if="item.model_id != model" i class="item-icon flex-stiff fas fa-fw" :class="drawer.icon"></i>
                                    <div class="problem-text" v-html="$options.filters.stripAndTruncate(item.name, 32, '')">NAME</div>
                                </div>
                            </template>
                        </template>

                        <template v-else-if="type == 'problem'">
                            <div class="item-row" @click="editProblem(item, index)" @mouseenter="highlightPath(item)" @mouseleave="removePathHighlight()">
                                <i v-if="item.is_valid" class="fal faw fas fa-code-branch fa-rotate-90" title="This problem has been linked to a valid path and is ready to assign"></i>
                                <i v-else class="far fa-exclamation-triangle red" title="This problem must be linked to a valid path before it is ready to assign"></i>
                                <div class="problem-text" v-html="$options.filters.stripAndTruncate(item.name, 32, '')">NAME</div>
                            </div>
                        </template>

                        <template v-else-if="type == 'path'">
                            <div class="item-row" @click="itemDetails(item, type, index)" @mouseenter="highlightPath(item)" @mouseleave="removePathHighlight()">
                                <i v-if="item.invalid > 0" class="far fa-exclamation-triangle red"></i>
                                <i v-else class="fal faw fas fa-code-branch fa-rotate-90"></i>
                                <div class="problem-text" v-html="$options.filters.stripAndTruncate(item.name, 32, '')">NAME</div>
                                <div class="item-count flex-r" title="Questions assigned to this path">
                                    <div>{{ item.problem_count }}</div>
                                    <i class="ml-1 mr-0 item-icon flex-stiff fal fa-fw fa-question-circle gray"></i>
                                </div>
                            </div>
                        </template>

                        <template v-else>
                            <div class="item-row" @click="itemDetails(item, type, index)">
                                <i class="item-icon flex-stiff fal fa-fw" :class="drawer.icon"></i>
                                <div class="problem-text" v-html="$options.filters.stripAndTruncate(item.name, 32, '')">NAME</div>
                                <div class="item-count flex-r" v-if="type == 'assignment'" title="Problems in this assignment">
                                    <div>{{ item.problem_ids ? (item.problem_ids.length ? item.problem_ids.length : 0) : 0 }}</div>
                                    <i class="ml-1 mr-0 item-icon flex-stiff fal fa-fw fa-question-circle gray"></i>
                                </div>
                                <div class="item-count flex-r" v-if="type == 'course'" title="Learners enrolled in this course">
                                    <div>{{ item.students }}</div>
                                    <i class="ml-1 mr-0 item-icon flex-stiff fal fa-fw fa-users gray"></i>
                                </div>
                            </div>
                        </template>

                    </template>

<!--                    <div v-for="(item, index) in filteredItems" class="item-row" :class="setActive(index)" @mouseenter="highlightPath(item)" @mouseleave="removePathHighlight()">-->

<!--                        <i v-if="type != 'problem' && type != 'path'" class="item-icon flex-stiff fal fa-fw" :class="drawer.icon"></i>-->

<!--                        <div v-if="item.header">{{ item.header }}</div>-->

<!--                        <div v-else-if="type == 'problem'" class="d-flex">-->
<!--                            <i v-if="item.path_id > 0" class="fal faw fas fa-code-branch fa-rotate-90" @click="editProblem(item, index)"></i>-->
<!--                            <i v-else class="fal faw fas fa-code-branch fa-rotate-90 transparent" @click="editProblem(item, index)"></i>-->
<!--                            <div class="problem-text" v-html="$options.filters.stripAndTruncate(item.name, 32, '')" @click="editProblem(item, index)">NAME</div>-->
<!--                        </div>-->

<!--                        <div v-else class="d-flex">-->
<!--                            <i v-if="item.invalid > 0" class="far fa-exclamation-triangle"></i>-->
<!--                            <i v-else-if="type == 'path'" class="fal faw fas fa-code-branch fa-rotate-90"></i>-->
<!--                            <div class="problem-text" v-html="$options.filters.stripAndTruncate(item.name, 32, '')" @click="itemDetails(item, type, index)">NAME</div>-->
<!--                        </div>-->

<!--                        <div v-if="type == 'problem'" class="ml-auto d-flex">-->
<!--                            <i class="fal fa-trash-alt hov-red" @click="deleteItem(item, 'problem')"></i>-->
<!--                        </div>-->

<!--                        <div v-else class="d-flex ml-auto">-->
<!--                            <i v-if="type != 'path' && (type != 'module' || item.model_id == model)" class="fal fa-trash-alt hov-red" @click="deleteItem(item, type)"></i>-->
<!--                            <div class="item-count" v-if="type == 'assignment'" >{{ item.problem_ids ? (item.problem_ids.length ? item.problem_ids.length : 0) : 0 }}</div>-->
<!--                            <div class="item-count" v-if="type == 'path'">{{ item.problem_count }}</div>-->
<!--                            <div class="item-count" v-if="type == 'course'">{{ item.students }}</div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>

                <div v-else-if="edit" class="drawer-body">
                    <model v-if="type == 'model'" :content="itemContent" :model="model" @close="closeDrawer"></model>
                    <assignment v-if="type == 'assignment'" :content="itemContent" :model="model" @close="closeDrawer" ></assignment>
                    <course v-if="type == 'course'" :content="itemContent" :model="model" @close="closeDrawer"></course>
                    <module v-if="type == 'module'" :content="itemContent" :model="model" @close="closeDrawer"></module>
                    <problem-path v-if="type == 'path'" :content="itemContent" :model="model" @close="closeDrawer"></problem-path>
                    <groups v-if="type == 'group'" :content="itemContent" :model="model" @close="closeDrawer"></groups>
                </div>


                <div class="mt-4 flex-r flex-center" style="font-size: 1.25em;" v-if="drawerLoading">
                    <div><i class="far fa-spinner fa-spin mr-2 blue"></i> {{ lang['general.loading'] }}</div>
                </div>

                <div v-else-if="!edit & items.length == 0" class="drawer-body">
                    <div class="px-2 prompt">{{ lang['empty_type'][type] }}</div>
                </div>

            </div>
            <div v-if="!drawerLoading && !edit && type != 'model'" class="button-footer">
                <button type="button" class="full-w btn btn-primary btn-gradient" :disabled="buttonStatus" v-on:click="createItem(type)">+ {{ lang['create_type'][type] }}</button>
            </div>
            <div v-if="edit" class="button-footer flex-r">
                <template v-if="currentItemProtected">
                    <button type="button" class="btn btn-primary full-w" :disabled="buttonStatus" @click="closeDrawer">{{ lang['button.close'] }}</button>
                </template>
                <template v-else>
                    <button type="button" class="btn btn-primary full-w" :disabled="buttonStatus" @click="saveItem">{{ lang['button.save'] }}</button>
                    <button v-if="creating == false && type != 'model'" type="button" class="btn btn-danger ml-3" :disabled="buttonStatus" @click="deleteCurrentItem()"><i class="fal fa-trash-alt white"></i></button>
                </template>
            </div>
        </div>

        <path-modal v-if="showModal == 'path'" :pathData="modalData" @close="closeModal"></path-modal>
        <learning-module-modal v-if="showModal == 'module'" :moduleData="modalData" @close="closeModal"></learning-module-modal>
        <delete-modal v-if="showModal == 'delete'" :itemData="modalData" @close="closeModal"></delete-modal>
        <disconnected-modal v-if="showModal == 'disconnected'" :connectData="modalData" @close="closeModal"></disconnected-modal>
        <stats-modal v-if="showModal == 'stats'" :statsData="modalData" @close="closeModal"></stats-modal>
        <timedout-modal v-if="showModal == 'timedout'" @close="closeModal"></timedout-modal>

    </div>

</template>

<script>
    import Swal from 'sweetalert2';
    export default {
		props: [ 'model', 'target', 'can_share', 'permissions' ],
        data() {
            var tabs = [];
            if (this.permissions.can_edit_model) {
                tabs.push({name: lang['general.model_settings'], type:'model', icon: "fa-cog", url: '/model/' + this.model});
            }
            if (this.permissions.can_edit_assignments) {
                tabs.push({name: lang['general.assignments'], type:'assignment', icon: "fa-file-alt", url: '/problemsets/' + this.model});
            }
            if (this.permissions.can_edit_courses) {
                tabs.push({name: lang['general.course_students'], type:'course', icon: "fa-book", url: '/courses/' + this.model});
            }
            if (this.permissions.can_edit_model) {
                tabs.push({name: lang['general.modules'], type:'module', icon: "fa-lightbulb", url: '/modules/' + this.model + '/details'});
            }
            if (this.permissions.can_edit_problems) {
                tabs.push({name: lang['general.paths'], type:'path', icon: "fa-code-branch fa-rotate-90", url:'/paths/' + this.model});
            }
            if (this.permissions.can_edit_problems) {
                tabs.push({name: lang['general.problems'], type:'problem', icon: "fa-question-circle", url:'/models/' + this.model + '/problems'});
            }
            if (this.permissions.can_edit_problems) {
                tabs.push({name: lang['general.groups'], type:'group', icon: "fa-ball-pile", url:'/problemgroups/' + this.model});
            }
            // if (this.can_edit_model) {
            //     tabs.push({name: lang['general.lms_integration'], type:'lms', icon: "fal fa-fw fa-exchange-alt"});
            // }
            if (this.permissions.can_share) {
                tabs.push({name: lang['general.collaborators'], type:'collaborator', icon: "fa-users", url:'/collaborators/' + this.model});
            }

            return {
                buttonStatus: false,
                drawer: {},
                creating: false,
                currentItem: null,
                currentItemType: null,
                currentItemProtected: false,
                edit: false,
                drawerLoading: false,
                filteredItems: [],
                icons: [],
                items:[],
                itemContent: {},
                modalData: {},
				paths: [],
                problems: [],
                type:"",
                lang: lang,
                searchTerm: "",
                selectedIndex: -1,
                showSharedModules: false,
                showModal: '',
                tabs: tabs,
            }
        },

        mounted() {
            if(this.target && this.target != 'collaborator') {
                this.openDrawer(this.target);
            }
            bus.$on('disableButton', status => {
                this.buttonStatus = (status == 'disable') ? true : false;
            });
            bus.$on('highlightPath', this.highlightPath);
            bus.$on('removeHighlight', this.removePathHighlight);
            bus.$on('deleteProblem', this.deleteItem);
            bus.$on('openModal', this.openModal);
            bus.$on('refreshDrawer', this.openDrawer);
            bus.$on('deletePath', this.deleteItem);
            bus.$on('popupError', this.popupError);
            bus.$on('checkTimeout', this.checkTimeout);
        },

        watch: {
            searchTerm(val) {
                if(!val.trim().length > 0) {
                    this.filteredItems = this.items;
                } else {
                    this.filteredItems = this.items.filter(item => {
                        return item.name.toLowerCase().includes(val.trim().toLowerCase())
                    });
                }
            }
        },

        methods: {
            openModal(modalType, data) {
                this.modalData = data;
                this.showModal = modalType;
            },

            closeModal() {
                this.modalData = {};
                this.showModal = '';
            },

            checkTimeout(){
                $.get('/timeout', response => {
                    //console.log("no timer error");
                })
                    .catch((error) => {
                        //console.log("timer error");
                        this.popupError(error);
                    });
            },

            popupError(error){
                if(error.status && error.status == 401){  // Unauthorized!
                    this.openModal("timedout", null);
                }
                else if(error.status && error.status == 419){
                    this.openModal("timedout", null);
                }

                else if (error.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
            },

            openDrawer(drawerType) {
                $(".nav-item").hide();
                $(".back-link").hide();
                this.items = [];
                this.itemContent = {};
                this.drawerLoading = true;
                this.searchTerm = "";
                this.type = drawerType;
                const { icon, name, type, url } = this.tabs.find(tab => { return tab.type == drawerType; });
                this.drawer = { name, icon };

                $.get(url,
                response => {
                    if(type == 'problem') {
                        this.problems = response.problems;
                        this.paths = [];
                        this.paths = response.paths;
                        for(let q = 0; q < this.problems.length; q++){
                            let problem = this.problems[q];
                            problem.name = (problem.name != null && problem.name != '') ? problem.name : problem.question;
                            // Check for valid paths...
                            if(problem.path_id > 0){
                                let foundMatch = false;
                                for(let p = 0; p < this.paths.length; p++){
                                    if(this.paths[p].id == problem.path_id){
                                        if(!this.paths[p].invalid){
                                            foundMatch = true;
                                        }
                                        problem.path = this.paths[p].path;
                                    }
                                }
                                if(!foundMatch){
                                    problem.is_valid = 0;
                                }
                            }
                            this.items.push(problem);
                        };

                    } else if(type == 'model') {
                        this.edit = true;
                        this.itemContent = response;
                    } else {
                        this.items = response;
                    }
                    this.drawerLoading = false;
                    this.filteredItems = this.items;
                }).catch((error) => {
                    this.popupError(error);
                });
            },

            closeDrawer() {
                $(".nav-item").show();
                $(".back-link").show();
                this.items = [];
                this.currentItem = null;
                this.currentItemType = null;
                bus.$emit('closeEditor');
                this.removePathHighlight();
                if(this.type == 'course') {
                    actionMode = "normal";
                    $("#detailsButtons").empty();
                }
                if(this.edit && this.type != 'model' && this.type != 'collaborator') {
                    this.openDrawer(this.type);
                } else {
                    this.type = "";
                }
                this.edit = false;
            },

            createItem(type) {
                this.checkTimeout();
                this.creating = true;
                this.currentItemProtected = false;
                if(type == 'problem') {
                    const problemData = {
                        pathId: 0,
                        modelId: +this.model,
                    }
                    editingProblem = true;
                    bus.$emit('addProblem', problemData, null, true);
                } else {
                    this.drawer.name = "Create " + type;
                    this.items = [];
                    this.edit = true;
                    switch(type){
                        case 'course':
                            this.itemContent = { collapsed:false };
                            break;
                        case 'module':
                            this.itemContent = {
                                id: 0,
                                decision_id: null,
                                group_id: null,
                                model_id: this.model,
                                link: '',
                                name: '',
                                new_module: true,
                                share_with_org: false,
                                uses: [],
                            };
                            break;
                        this.itemContent = {};
                    }
                }
            },

			itemDetails (item, type, index) {
                this.selectedIndex = index;
                this.currentItem = item;
                this.currentItemType = type;
                this.currentItemProtected = false;
                if(type == 'model' || (type == 'module' && item.model_id != this.model)){
                    this.currentItemProtected = true;
                }
                this.creating = false;
                if(type != 'problem') {
                    this.itemContent = [];
                    this.drawer.name = "Edit " + type;
                    this.edit = true;

                    switch(type) {
                        case 'assignment':
                            this.itemContent = { assignment: item, paths: this.paths };
                            break;
                        case 'course':
                        case 'path':
                            this.itemContent = item;
                            break;
                        case 'module':
                            this.itemContent = item;
                            this.itemContent.new_module = false;
                            break;
                        case 'group':
                            this.itemContent = item;
                            var decision_ids = [];
                            this.items.forEach(group => {
                                if(group.decision_ids) {
                                    decision_ids.push(...group.decision_ids);
                                }
                            });
                            this.itemContent.used = decision_ids;
                            break;
                    }
                    this.items = [];
                }
                this.checkTimeout();
            },

            setActive(index) {
                if (this.type == 'problem') {
                    return this.selectedIndex == index ? 'selected' : '';
                } else {
                    this.selectedIndex = -1;
                }
            },

            deleteItem(item, type) {
                var url = "";
                var $this = this;
                const { id, model_id: modelId } = item;
                Swal({
                    title: type == 'problem' ? lang['general.are_you_sure_delete_problem'] : type == 'module' ? lang['general.are_you_sure_delete_module'] : lang['general.are_you_sure'],
                    text: type == 'problem' ? lang['general.are_you_sure_delete_problem_description'] : type == 'module' ? lang['general.are_you_sure_delete_module_description'] : lang['general.are_you_sure_delete'],
                    type: 'warning',
                    buttonsStyling: false,
                    cancelButtonClass: 'btn btn-secondary',
                    confirmButtonClass: 'btn btn-delete mr-3',
                    confirmButtonText: lang['button.delete'],
                    cancelButtonText: lang['button.cancel'],
                    focusConfirm: false,
                    showCancelButton: true,
                }).then(function(confirm) {
                    if(confirm.value) {
                        switch(type) {
                            case 'assignment' :
                                url = '/problemsets/' + id + '/model-id/' + item.model_id;
                                break;
                            case 'course':
                                url = "/courses/" + id;
                                break;
                            case 'group':
                                url = '/problemgroups/' + id + '/model-id/' + item.model_id;
                                break;
                            case 'path':
                                url = '/paths/' + id + '/model/' + item.model_id;
                                break;
                            case 'problem':
                                url = '/models/' + item.model_id + '/problem/' + id;
                                break;
                            case 'module':
                                url = '/modules/' + id;
                                break;
                        }
                        $.ajax({
                            type: 'delete',
                            url: url,
                            success: function (response) {
                                if(type != 'path' && type != 'problem') {
                                    $this.items.splice($this.items.indexOf(item), 1);
                                } else if ($this.type == 'problem') {
                                    $this.openDrawer('problem');
                                } else if ($this.type == 'path') {
                                    type == 'problem'
                                        ? bus.$emit('updatePathProblems', item, 'delete')
                                        : bus.$emit('removePath');
                                }
                                if ($this.type == 'module') {
                                    removeModuleReferences(id);
                                }
                                $this.closeDrawer();
                            }
                        });
                    }
                });
            },

            deleteCurrentItem() {
                this.deleteItem(this.currentItem, this.currentItemType);
            },

            saveItem() {
                bus.$emit('save');
            },

            editProblem(problem, index) {
                this.selectedIndex = index;
                this.currentItem = problem;
                this.currentItemType = 'problem';
                editingProblem = true;
                $.get('/paths/' + problem.path_id + '/model/' + problem.model_id,
                res => {
                    const path = res;
                    bus.$emit('editProblem', problem, path, true);
                })
                .catch((error) => {
                    bus.$emit('popupError', error);
                });
            },

            highlightPath(item) {
                if(item.path) {
                    tracePathOnHover(item.path);
                } else if(item.path_id > 0) {
                    var selectedPath = [];
                    dbProfiles.forEach(path => {
                        if(path.id && path.id == item.path_id) {
                            selectedPath = path;
                        }
                    })
                    tracePathOnHover(selectedPath.path);
                }
            },

            removePathHighlight() {
                clearTrace();
            }
        }
    }
</script>
